export default "__VITE_ASSET__D3rC$heU__"